<template>
  <div class="header" v-bind:style="{ 'background-image': background_img }">
      <div class="overlay" v-bind:class="{ active: menu, dim: show_subnav }">
        <div class="wrap" :class="{ compact: compact }">
            <div class="top">
              <div>
                <router-link to="/" class="top"><img class="logo" src="../../assets/lyninx-text.svg"></router-link>
              </div>
            </div>
            <div class="info" v-bind:class="{ 'external': image_source }">
              <a :href="image_source" target="_blank">{{ image_name }} {{ image_credits }}</a>
            </div>
            <div class="nav" :class="{ active: show_subnav }">
                <div class="menu" v-show="narrow">
                  <svg class="menu-icon" width="50" height="50" v-on:click="toggle_menu()">
                    <path d="M8 12 H 40 
                             M8 22 H 40
                             M8 32 H 40" fill="transparent" stroke="white" stroke-width="3"></path>
                  </svg>
                </div>
                <div class="primary" v-show="!narrow">
                    <!-- <div class="sec">Explore</div> 
                    <div class="sec">Releases</div>  -->
                    <router-link to="/diary" class="link sec">Diary</router-link> 
                    <a class="link sec" href="https://twitter.com/lyninxmusic" target="_blank">Twitter</a>
                    <a class="link sec" href="https://open.spotify.com/artist/0bhHLMarJ0ualnJyScHVat" target="_blank">Spotify</a>
                </div>
                <div class="context" @click="menu = !menu">
                    <div class="title">{{page}}</div>
                    <div class="meta">
                      <div>{{context}}</div>
                      <div>{{date}}</div>
                    </div>
                </div>
            </div>
            <div class="subnav" v-show="show_subnav">
              <div class="item" v-on:click="toggle_menu()"><router-link to="/diary" class="link">Diary</router-link></div>
              <div class="item" v-on:click="toggle_menu()"><a class="link" href="https://twitter.com/lyninxmusic" target="_blank" v-on:click="toggle_menu()">Twitter</a></div>
              <div class="item" v-on:click="toggle_menu()"><a class="link" href="https://open.spotify.com/artist/0bhHLMarJ0ualnJyScHVat" target="_blank" v-on:click="toggle_menu()">Spotify</a></div>
            </div>
        </div>
      </div>
  </div>
</template>
<script>
import DateUtil from '../../util/date'
export default {
  props: ['compact', 'width'],
  data: () => {
    return {
      menu: false,
      page: 'Home',
      context: '',
      date: null,
      image_name: '',
      image_credits: '',
      image_source: null,
      background_img: '',
      narrow: false,
      show_subnav: false
    }
  },
  created: function(){
    this.set_layout()
    this.update_route_info()
  },
  methods: {
    update_image() {
      if(this.$store.state.image.url){
        this.background_img = 'url(' + this.$store.state.image.url + ')'
        this.image_name = this.$store.state.image.meta.title
        this.image_source = this.$store.state.image.meta.source
        if(this.$store.state.image.meta.artist) {
          this.image_credits = 'by ' + this.$store.state.image.meta.artist
        } else {
          this.image_credits = ''
        }
      } else {
        this.background_img = ''
        this.image_name = ''
        this.image_credits = ''
        this.image_source = ''
      }
    },
    update_route_info() {
      this.page = this.$store.state.meta.title
      this.context = this.$store.state.meta.context
      this.date = DateUtil.format(new Date(this.$store.state.meta.updated))
    },
    set_layout() {
      if(this.width < 500) {
        this.narrow = true
      } else {
        this.narrow = false
        this.show_subnav = false
      }
    },
    toggle_menu() {
      this.show_subnav = !this.show_subnav
    }
  },
  watch: {
    width: function(){
      this.set_layout()
    },
    '$store.state.image' (){
      this.update_image()
    },
    '$store.state.meta' (){
      this.update_route_info()
    },    
  } 
}
</script>